import * as React from "react"
import injectSheet from "react-jss"
import { LOADING } from "@/helpers/stateMachine"
import cn from "classnames"
import { color } from "@xingternal/360-styles/helpers"
import { Icon, Text } from "@xingternal/360-components"
import { LoadingText } from "@xingternal/winery-ui/lib/LoadingText"
import { kpiValueFormatter } from "@/helpers"

const styles = {
  value: { composes: "flex items-center" },
  valueLoadingText: { composes: "my8" },
  valueIcon: { composes: "mr8" },
  valueText: { composes: "nowrap", lineHeight: "24px" },
  valueTextNegative: {
    color: ({ reverseComparison }) => !reverseComparison && color("red"),
  },
  valueTextPositive: {
    color: ({ reverseComparison }) => reverseComparison && color("red"),
  },
}

const Value = injectSheet(styles)(
  ({
    children,
    classes,
    comparisonValue,
    formatter,
    icon,
    name,
    status,
    value,
  }) => {
    const formattedKpiValue = kpiValueFormatter({
      comparisonValue,
      formatter,
      value,
    })
    const valueTextCx = cn(classes.valueText, {
      [classes.valueTextNegative]:
        (comparisonValue && parseInt(formattedKpiValue, 10) < 0) ||
        parseInt(value) < 0,
      [classes.valueTextPositive]:
        comparisonValue && parseInt(formattedKpiValue, 10) > 0,
    })

    return (
      <div className={classes.value}>
        {icon && <Icon className={classes.valueIcon} name={icon} size={16} />}
        {status === LOADING ? (
          <LoadingText dark max={30} className={classes.valueLoadingText} />
        ) : (
          <Text className={valueTextCx} size={22} bold>
            <span data-testid="kpiValue">{formattedKpiValue}</span>
          </Text>
        )}
      </div>
    )
  },
)

const KpiValue = ({ className, ...props }) => (
  <div className={className}>
    <Value {...props} />
  </div>
)

export const StyledKpiValue = injectSheet(styles)(KpiValue)
export default KpiValue
